import React, { useState, useCallback } from 'react';
import _ from 'lodash';

const Context = React.createContext();

export const AlertProvider = ({ children }) => {
    const [alerts, setAlerts] = useState([]);

    const addAlert = useCallback((alert) => {
        const matched = alerts.find(a => {
            return alert.key === a.key;
        });

        if (_.isEmpty(matched)) { setAlerts((alerts) => ([...alerts, alert])); }
    }, [alerts]);

    const removeAlert = useCallback((key) => {
        const updatedAlerts = alerts.filter((alert) => key !== alert.key);

        setAlerts(updatedAlerts);
    }, [alerts]);

    const value = { alerts, addAlert, removeAlert };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useAlertStore = () => React.useContext(Context);